import { useSelector } from 'react-redux';
import useRouter from 'Router/index';
import { getVerifiedPhenotypeId } from 'PhenotypeView/store/selectors';
export const useValidatedPhenotypeId = () => {
    const { getReferrerData } = useRouter();
    const referrerData = getReferrerData();
    const phenotypeId = useSelector(getVerifiedPhenotypeId);
    const validatedPhenotypeId = (referrerData === null || referrerData === void 0 ? void 0 : referrerData.phenotypeId) || phenotypeId || '';
    return validatedPhenotypeId;
};
